const KEY_CODE = {
    ENTER: 13,
    TAB: 9,
};
export const META_DATA_KEY = 'META_DATA';
export const PLUGIN_VERSION_KEY = 'pluginVersion';
export const WEB_PLUGIN_VERSION_KEY = 'webPluginVersion';
export const PLATFORM_KEY = 'platform';
export const SUB_PLATFORM_KEY = 'subPlatform';
export const LATEST_PLUGIN_VERSION_WITH_COUNT_BADGE = '10.3.19'; // latest version that dosnt support badge indicator without counter
export const AUTO_OPEN_DISABLED_PLUGIN_VERSION = '11.0.0'; // auto open is turned off from this core plugin version
export const APP_ID = 'WEB_PLUGIN';
export const SEARCH_STATUS = {
    IDLE: 'IDLE',
    SEARCHING: 'SEARCHING',
    RESOLVED: 'RESOLVED',
    REJECTED: 'REJECTED',
    MAX_SEARCHES_REACHED: 'MAX_SEARCHES_REACHED',
    RETRYING_SEARCH: 'RETRYING_SEARCH',
    PARSER_ERROR: 'PARSER_ERROR',
    REACH_SEARCH_LIMIT: 'REACH_SEARCH_LIMIT',
};
export const CONTACT_STATES = {
    NOT_FOUND: 'not_found',
    SHOWN: 'shown',
    REFRESHED: 'refreshed',
    NOT_SHOWN: 'not_shown',
    MISS: 'miss',
};
export const SEARCH_RESULTS = {
    MAX_SEARCH_RESULT: -2,
    EMPTY_RESULT: 0,
    EMPTY_INDICATION: '',
};
export { KEY_CODE };
export const CONTACT_BLOCKED_TEXT = 'Users with free accounts cannot view this contact due to compliance regulations';
export const ALPHABET_LETTERS_REGEX = /^[\p{Script=Latin}_ .]+$/u;
export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
// tslint:disable-next-line
export const ALPHABET_NUMBERS_CHARS_REGEX = /^[a-zA-Z0-9,#\-.\s]*$/i;
export const EVENT_TYPE = {
    CRM: 'crm',
    LIST: 'list',
    SEQUENCE: 'sequence',
    contactUpdateDetailsUpdateCrmClicked: 'contact_update_details_update_crm_clicked',
};
export const CREDIT_TYPES = {
    EMAIL: 'email',
    PHONE: 'phone',
    BOTH: 'both',
    UNLIMITED_CREDITS: 'unlimited-credits',
    BULK: 'bulk',
};
export const BRAZE_EVENT_TYPES = {
    CONTENT_CARD_VIEWED: 'plugin_content_card_viewed',
    PLUGIN_CARD_DISMISSED: 'plugin_card_dismissed',
    PLUGIN_CARD_PRIMARY_BTN_CLICKED: 'plugin_card_primary_btn_clicked',
    PLUGIN_CARD_SECONDARY_BTN_CLICKED: 'plugin_card_secondary_btn_clicked',
    PLUGIN_CARD_IMAGE_CLICKED: 'plugin_card_image_clicked',
};
